import { Pipe, PipeTransform } from '@angular/core';
import { TruncateLocation } from '../enums/truncate-location.enum';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, limit = 100, truncateLocation: TruncateLocation = TruncateLocation.End): string {
    if (!value) return '';
    if (value.length <= limit) return value;
    
    const fileFormat = value.split('.')[1];
    
    switch(truncateLocation){
      case TruncateLocation.File:
        return value.substring(0, limit - fileFormat.length - 3) + '...' + fileFormat;
      case TruncateLocation.End:
      default:
        return value.substring(0, limit) + '...';
    }
  }
}
